import React, { useState } from 'react';
import { callPlanListing } from '../../api-services';
import AddPlan from './AddPlan';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../components/TableManager';
import moment from 'moment';

const table = createTable();

const Plans = () => {
  const [addPlan, setAddPlan] = useState(false);

  const handleDuration = (duration) => {
    switch (duration) {
      case 'M':
        return 'Monthly';
      case 'Q':
        return 'Quarterly';
      case 'H':
        return 'Half Yearly';
      case 'Y':
        return 'Yearly';

      default:
        return '---';
    }
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      isSortable: true,
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
    }),

    table.createDataColumn('plan_name', {
      id: 'plan_name',
      header: 'Name',
      textAlign: 'left',
      isSortable: true,
    }),
    table.createDataColumn('plan_type', {
      id: 'plan_type',
      header: 'Type',
      cell: (props) => (props.getValue() === 'P' ? 'Paid' : 'Free'),
    }),
    table.createDataColumn('plan_cost', {
      id: 'plan_cost',
      header: 'Cost',
      isSortable: true,
    }),
    table.createDataColumn('plan_status', {
      id: 'plan_status',
      header: 'Status',
      cell: (props) => (props.getValue() === 'A' ? 'Activated' : 'Deactivated'),
    }),
    table.createDataColumn('plan_duration', {
      id: 'plan_duration',
      header: 'Duration',
      cell: (props) => handleDuration(props.getValue()),
    }),
    table.createDataColumn('free_mins', {
      id: 'free_mins',
      header: 'Free mins',
      isSortable: true,
    }),
    table.createDataColumn('free_sms', {
      id: 'free_sms',
      header: 'Free SMS',
      isSortable: true,
    }),
    table.createDataColumn('plan_comment', {
      id: 'plan_comment',
      header: 'Comment',
      textAlign: 'left',
    }),
    table.createDataColumn('plan_tax', {
      id: 'plan_tax',
      header: 'Tax',
      isSortable: true,
    }),
    table.createDataColumn('security_charge', {
      id: 'security_charge',
      header: 'Security charge',
      isSortable: true,
    }),
    table.createDataColumn('card_process_fee', {
      id: 'card_process_fee',
      header: 'Card Process Fee',
      isSortable: true,
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        // filter={filters}
        fetcherKey="PlanListing"
        fetcherFn={callPlanListing}
        title="Plans"
      />

      <div className="add_action text-center d-flex flex-column justify-content-center align-items-center w-100 pointer">
        <button
          type="button"
          className="btn btn-primary d-flex align-items-center justify-content-center "
          onClick={() => setAddPlan(true)}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
        <label className="mt-2" style={{ color: '#000000' }}>
          Add Plan
        </label>
      </div>

      {addPlan && (
        <AddPlan
          setOpenModal={setAddPlan}
          openModal={addPlan}
          // editData={editData}
          // setEditData={setEditData}
        />
      )}
    </>
  );
};

export default Plans;
